import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    height: 2.75rem;
    display: flex;
    align-items: center;
`

export const ImagePlaceholder = styled("img")`
    && {
        border-radius: 50%;
        background-size: cover;
        background-repeat: no-repeat;
        margin: 0 0.75rem 0 0;
        flex-shrink: 0;
    }
    &&& {
        width: 1.25rem;
        height: 1.25rem;
    }
`
